import React from 'react'
import { Message } from 'semantic-ui-react'

const Notification = ({ message, errColor }) => {
    return (
        <div>
            <Message color={errColor}>{ message }</Message>
        </div>
    )
}

export default Notification
